export default __webpack_public_path__ + "static/media/services-hero.fe6aed05.svg";